'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const damHelper = require('./dam/dam-helper');
const banner = '.js-banner';

function changeSrcVideo() {
    if ($('.js-bannersmall-video').length > 0) {
        if (isSmallView()) {
            $('.js-bannersmall-video source').attr('src', $('.js-bannersmall-video source').data('mobilev'));
            $('.js-bannersmall-video')[0].load();
        } else {
            $('.js-bannersmall-video source').attr('src', $('.js-bannersmall-video source').data('desktopv'));
            $('.js-bannersmall-video')[0].load();
        }
    }
}

function changeSrcImage() {
    const bannerImages = $('.js-banner-image');
    if (!bannerImages.length) {
        return;
    }
    for (const banner of bannerImages) {
        const $banner = $(banner);
        if (isSmallView() && $banner.data('mobilev')) {
            $banner.attr('data-src', $banner.data('mobilev'));
        } else {
            $banner.attr('data-src', $banner.data('desktopv'));
        }
        damHelper.updateImages($banner.parent());
    }
}


/**
 * Tests if the dragList element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => document.querySelectorAll(banner).length > 0;


const changeSrcForMedia = {
    init: () => {
        if (shouldInit()) {
            changeSrcVideo();
            changeSrcImage();
        }
    }
};

/**
 * Fix for PD preview
 */
let prevWidth = window.innerWidth;
window.addEventListener('resize', function() {
    if (window.innerWidth !== prevWidth) {
        prevWidth = window.innerWidth;
        changeSrcForMedia.init();
    }
});

module.exports = changeSrcForMedia;
